import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueCookies from 'vue-cookies';
import VueMeta from 'vue-meta'
import Routes from './routes'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import Vue config
import { backendURL, publicPath } from '../vue.config'

// Use packages
Vue.use(VueResource);
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(VueMeta)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Register routes
const router = new VueRouter({
  routes: Routes,
  mode: 'hash',
  base: publicPath
});

// Instance Properties
Vue.prototype.GLOBAL_CONSTANTS = {
  metaInfo: {
    appName: "Entity-centric Corpus Exploration"
  },
  //BACKEND_URL: 'http://139.177.181.219:8080'
  BACKEND_URL: backendURL

}

// Init Vue instance
new Vue({
  el: '#app',
  render: h => h(App),
  router: router
})




// WEBPACK FOOTER //
// ./src/main.js